import * as React from 'react';
import { cn } from '../../../../utils';
import { Body2Typography, CaptionTypography } from '../../../atoms';
import type { ComplexTreeItemTitleProps } from '../types';

export const ComplexTreeItemTitle: React.FC<ComplexTreeItemTitleProps> = ({
	title,
	subtitle,
	isTruncated,
	truncatedCount,
	truncatedText,
	isDepthLimited,
	depthLimitedText,
	matchesSearch,
}) => {
	const truncatedTextValue = truncatedText && truncatedCount !== undefined ? truncatedText(truncatedCount) : ``;
	return (
		<div className={'flex min-w-0 flex-col gap-[0.2rem] py-[0.4rem]'} data-testid="complex-tree-item-title">
			<Body2Typography
				className={cn(
					'truncate text-[1rem] font-normal text-primary',
					matchesSearch && 'rounded-sm bg-accent font-semibold text-white'
				)}
			>
				{title}
			</Body2Typography>
			{isTruncated && (
				<CaptionTypography className="text-secondary">{truncatedTextValue}</CaptionTypography>
			)}
			{isDepthLimited && <CaptionTypography className="text-error">{depthLimitedText}</CaptionTypography>}
			{subtitle && !isTruncated && !isDepthLimited && (
				<CaptionTypography className={'truncate text-secondary'}>{subtitle}</CaptionTypography>
			)}
		</div>
	);
};
